// extracted by mini-css-extract-plugin
export var article = "index-module--article--NwDye";
export var left = "index-module--left--r-6cN";
export var right = "index-module--right--TWQji";
export var textContainer = "index-module--textContainer--jNe0u";